import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ConstantsService } from '../constant/constants.service';
import { ImportResponse } from 'src/app/shared/models/api-response/import-response';
import { GenericCrudService } from '../generic-crud.service';
import { HttpHeaders } from '@angular/common/http';
import { Prestation } from 'src/app/shared/models/prestation';

@Injectable({
	providedIn: 'root'
})
export class MiseEnOeuvreEmploiService {
	constructor(
		private appConstants: ConstantsService,
		private genericCrudService: GenericCrudService
	) {}

	getAllMiseEnOeuvreEmploi(): Observable<Prestation[]> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.miseEnOeuvreEmploiUrl}/all`,
			'getAllMiseEnOeuvreEmploi'
		);
	}


	getMiseEnOeuvreEmploiById(id: number): Observable<Prestation> {
		return this.genericCrudService.genericGetAPIData(
			`${this.appConstants.miseEnOeuvreEmploiUrl}/get/${id}`,
			'getMiseEnOeuvreEmploiById'
		);
	}

	updateMiseEnOeuvreEmploi(miseEnOeuvreEmploi: Prestation): Observable<void> {
		return this.genericCrudService.genericPutDataToAPI(
			`${this.appConstants.miseEnOeuvreEmploiUrl}/update/${miseEnOeuvreEmploi.id}`,
			'updateMiseEnOeuvreEmploi',
			miseEnOeuvreEmploi
		);
	}

	addMiseEnOeuvreEmploi(miseEnOeuvreEmploi: Prestation): Observable<void> {
		return this.genericCrudService.genericPostDataToAPI(
			`${this.appConstants.miseEnOeuvreEmploiUrl}/add`,
			'addMiseEnOeuvreEmploi',
			miseEnOeuvreEmploi
		);
	}

	deleteMiseEnOeuvreEmploi(miseEnOeuvreEmploiId: number): Observable<void> {
		return this.genericCrudService.genericDeleteAPIDataByID(
			`${this.appConstants.miseEnOeuvreEmploiUrl}/delete/${miseEnOeuvreEmploiId}`,
			`deleteMiseEnOeuvreEmploi`
		);
	}

}
